import React from "react";

// create context
export const BOOKING_CONTEXT = React.createContext();
export const LOADER_CONTEXT = React.createContext();
export const CONTINUE_CONTEXT = React.createContext();
